module.exports = __webpack_public_path__ + "static/hsbc2-7cddcba9c2e6d32a85f2ddfcd3d5a6b3.png";